import React from 'react';
import PropTypes from 'prop-types';

import Typography from '../Typography/Typography';
import Box from '../Styled/Box';
import Card from './Card';

import { useIsMobileLayout } from '../../hooks';

const FormCard = ({
  title,
  subtitle,
  children,
  cardProps,
  titleProps,
  subtitleProps,
}) => {
  const isMobile = useIsMobileLayout();

  return (
    <Card width={isMobile ? '100%' : 440} {...cardProps}>
      <Typography
        block
        variant='h4'
        color='coldgrey600'
        {...titleProps}
      >
        {title}
      </Typography>

      <Typography
        block
        mt={3}
        color='coldgrey600'
        variant='body'
        {...subtitleProps}
      >
        {subtitle}
      </Typography>

      <Box mt={4}>
        {children}
      </Box>
    </Card>
  );
};

FormCard.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cardProps: PropTypes.object,
  titleProps: PropTypes.object,
  subtitleProps: PropTypes.object,
};

FormCard.defaultProps = {
  children: null,
  title: '',
  subtitle: '',
  cardProps: {},
  titleProps: {},
  subtitleProps: {},
};

export default FormCard;
